const T_PREFIX = "error-page";

export const errorPageTrns = {
  title: `${T_PREFIX}.title`,
  description: `${T_PREFIX}.description`,

  goHomeBtn: `${T_PREFIX}.go-home-btn`,
  contactUsBtn: `${T_PREFIX}.contact-us-btn`,
};

export const metaTrns = {
  title: `${T_PREFIX}.meta.title`,
  description: `${T_PREFIX}.meta.description`,
};
